import { getMessages } from '../../../../../../store/constants';

export const TRIAL_EXTEND_BUTTON = getMessages().getText('dialog.blocker.button-trial-extend');
